export default __webpack_public_path__ + "static/81493-e0b0817dcddbea0729e6033db6ee8d70.jpg";